module.exports = __webpack_public_path__ + "static/Personalisation@3x-ef10e816d1c7ba321ffea3d9df69fa54.png";